export const endpoints = {
  commodityToTarget: 'fc/targetCommodity/transformCommodityToTarget',
  targetCommodityCategory: 'fc/targetCommodityCategory',
  kegSize: 'fc/commodityKegSize',
  targetCommodity: 'fc/targetCommodity',
  targetCommodityTarget: 'fc/targetCommodityTarget',
}
